<template>
  <section>
    <header class="flex relative items-center text-22 text-white gap-1">
      <VideoPlayIcon class="w-7 h-7" />
      <div class="relative">
        {{ $t('video-player.recommended-videos') }}
      </div>
      <HideShowButton
        v-if="isMobile"
        class="absolute right-0 top-0.5"
        event="click_recommendVideoHideShowButton"
        @hide-show="handleShowHide"
      />
      <div class="flex-grow border-b border-[#666666]"></div>
    </header>
    <TransitionSlot>
      <div v-if="isShow" class="flex flex-col gap-2 mt-4 h-auto">
        <RecommendationItem v-for="(item, index) in items" :key="item._id" :item="item" :index="index" />
      </div>
    </TransitionSlot>
  </section>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import VideoPlayIcon from '@/static/images/video/video-play2.svg?inline';
import RecommendationItem from './RecommendationItem';
import HideShowButton from './HideShowButton';
import TransitionSlot from './TransitionSlot';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  components: { VideoPlayIcon, RecommendationItem, HideShowButton, TransitionSlot },
  props: {
    items: {
      type: Array,
      require: true,
    },
  },
  setup() {
    const isShow = ref(true);
    const handleShowHide = (toggle) => (isShow.value = toggle);
    const { isMobile } = useDevice();
    return { handleShowHide, isShow, isMobile };
  },
});
</script>
